import { isBrowser } from 'src/lib/util/dom'
import * as http from 'http'

export const getPath = (req?: http.IncomingMessage) => {
  if (req && req.url) {
    return new URL(req.url, 'http://_').pathname
  }
  if (isBrowser) {
    return window.location.pathname
  }
}

export const getRedirectUrl = (
  pathname: string,
  req?: http.IncomingMessage,
  encodedRedirect?: string
) => {
  const redirect = encodedRedirect ?? encodeURIComponent(getPath(req) ?? '/')
  const url = new URL(pathname, 'http://_')
  url.searchParams.set('redirect', redirect)
  return `${url.pathname}?${url.searchParams.toString()}`
}
